import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

// Che do gop trang cua Pancake: chon vai trang, mot trang, hay tat ca. Trang
// chinh ghi lua chon, cot hoi thoai doc lai. Mang rong = tat ca.
const KEY = 'bonboz_selected_inboxes';

// TAP DA GOP — khac voi TRANG DANG XEM o tren, va day la hai viec khac nhau.
//
// VI SAO PHAI TACH: `KEY` bi ghi de moi lan dieu huong toi mot route co
// `inbox_id` (ChatList.vue, watch `conversationInbox`) — co y, de man Thong ke
// biet dang xem trang nao. Nghia la bam vao MOT trang la lua chon co lai con
// mot. Neu menu tren thanh tren doc `KEY` thi bam trang dau tien la danh sach
// tu rut xuong con mot muc, khong con nhay qua lai duoc nua.
//
// `KEY_GOP` chi doi khi nguoi dung BAM XONG o hop thoai "Che do gop trang",
// khong ai khac ghi vao. Nho vay no la tap trang ON DINH de menu liet ke.
// Mang rong = tat ca, giong quy uoc cua `KEY`.
const KEY_GOP = 'bonboz_merged_inboxes';

const chuanHoa = ids => [...new Set((ids ?? []).map(Number))].filter(Boolean);

export function useSelectedPages() {
  const { uiSettings, updateUISettings } = useUISettings();

  const selectedInboxIds = computed(() => uiSettings.value?.[KEY] ?? []);
  const isAllSelected = computed(() => selectedInboxIds.value.length === 0);

  const mergedInboxIds = computed(() => uiSettings.value?.[KEY_GOP] ?? []);
  const isAllMerged = computed(() => mergedInboxIds.value.length === 0);

  const setSelectedInboxes = ids => {
    updateUISettings({ [KEY]: chuanHoa(ids) });
  };

  const selectAllInboxes = () => setSelectedInboxes([]);

  // Ghi CA HAI khoa trong MOT lan goi. `updateUISettings` tron `settings` vao
  // ban chup `uiSettings.value` doc tai thoi diem goi, nen hai lan goi lien
  // tiep thi lan sau ghi de lan truoc — khoa nao ghi truoc se mat.
  const setMergedInboxes = ids => {
    const unique = chuanHoa(ids);
    updateUISettings({ [KEY_GOP]: unique, [KEY]: unique });
  };

  // Dung chung cho moi cho loc: hoi thoai co thuoc lua chon hien tai khong.
  const matchesSelection = conversation => {
    if (isAllSelected.value) return true;
    return selectedInboxIds.value.includes(Number(conversation?.inbox_id));
  };

  return {
    selectedInboxIds,
    isAllSelected,
    setSelectedInboxes,
    selectAllInboxes,
    matchesSelection,
    mergedInboxIds,
    isAllMerged,
    setMergedInboxes,
  };
}
